import type { Question } from '@mentimeter/legacy-series-types/question';
import type { Slide as VotingSlide } from '../../compatibility-overrides/voting-types';
import type { CompatibilitySlide } from '../../compatibility-types';
import {
  DEFAULT_RESPONSE_RANGE,
  RESPONSE_POLICY_SINGLE_RESPONSE_ALL_CHOICES,
} from '../../constants';
import { getOrSetCache, type WithCache } from '../../utils/get-or-set-cache';
import { scalesResponseRangeLabelsToQuestionDimensions } from '../converters/interactive-content/slide-scales-response-range-labels-to-question-dimensions';
import type { CommonQuestionProperty } from './get-common-question-property';

export const getQuestionScalesProperty = (
  target: CompatibilitySlide<'scales'> | VotingSlide<'scales'>,
  prop: keyof Question,
) => {
  const interactiveContent = target.interactiveContents?.[0];
  const staticContents = target.staticContent;
  const { interactiveContentStyling, styledTitle } = staticContents;

  if (prop === 'question_styled') {
    return styledTitle ?? {};
  }

  if (interactiveContent) {
    switch (prop as keyof Omit<Question, CommonQuestionProperty>) {
      case 'scales_total_average':
        return interactiveContentStyling?.showAverage;
      case 'hide_skip':
        return (
          interactiveContent.responsePolicy ===
          RESPONSE_POLICY_SINGLE_RESPONSE_ALL_CHOICES
        );
      case 'dimensions':
        const dimensions = scalesResponseRangeLabelsToQuestionDimensions(
          interactiveContentStyling?.responseRangeLabels,
        );

        const cacheKey = JSON.stringify(dimensions);
        return getOrSetCache(
          target as WithCache<CompatibilitySlide>,
          'dimensions',
          cacheKey,
          dimensions,
        );
      case 'range':
        return interactiveContent.responseRange ?? DEFAULT_RESPONSE_RANGE;
      default:
        return undefined;
    }
  }
};
